// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"238":"63dc1ade","239":"ad40150f","455":"1b0a6a6b","977":"b584b783"}[chunkId] + ".chunk.js";
};